import { saveDownloadedFile, type DownloadedFile } from "../lib/browserDownload";
import type { PortalInvoice } from "../lib/gboModels";
import { normalizeInvoiceReferenceCode } from "../lib/lookupCode";
import { gboApi } from "./gboApiBase";

export const portalInvoiceApi = gboApi.injectEndpoints({
  endpoints: (builder) => ({
    getPortalInvoice: builder.query<PortalInvoice, { scope: string; invoiceCode: string }>({
      query: ({ invoiceCode }) => ({
        url: `portal/invoices/${encodeURIComponent(normalizeInvoiceReferenceCode(invoiceCode))}`,
      }),
      keepUnusedDataFor: 0,
    }),
    downloadPortalInvoice: builder.mutation<null, string>({
      async queryFn(id, _api, _options, baseQuery) {
        const result = await baseQuery({
          url: `portal/invoices/${encodeURIComponent(id)}/pdf`,
          responseType: "file",
          fallbackFileName: "Invoice.pdf",
        });
        if (result.error) return { error: result.error };
        saveDownloadedFile(result.data as DownloadedFile);
        return { data: null };
      },
    }),
    downloadPortalReceipt: builder.mutation<null, string>({
      async queryFn(id, _api, _options, baseQuery) {
        const result = await baseQuery({
          url: `portal/payments/${encodeURIComponent(id)}/receipt`,
          responseType: "file",
          fallbackFileName: "Receipt.pdf",
        });
        if (result.error) return { error: result.error };
        saveDownloadedFile(result.data as DownloadedFile);
        return { data: null };
      },
    }),
  }),
});
export const {
  useGetPortalInvoiceQuery,
  useDownloadPortalInvoiceMutation,
  useDownloadPortalReceiptMutation,
} = portalInvoiceApi;
